import { call, takeEvery, put } from "redux-saga/effects";
import * as types from "../../constants";

import * as Services from "./service";

function* upgradePlanPackageSaga(payload) {
  const data = payload.data;
  const response = yield call(Services.upgradePlanPackageService, data);
  if (response && response.confirmation_url) {
    window.location.href = response.confirmation_url;
  } else {
    window.location.href = "";
  }
}
function* getDataPlanSaga() {
  const response = yield call(Services.getDataPlanService);
  if (response) {
    yield put({
      type: types.GET_DATA_PLAN_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

function* sagaActions() {
  yield takeEvery(types.UPGRADE_PALN_PACKAGE, upgradePlanPackageSaga);
  yield takeEvery(types.GET_DATA_PLAN, getDataPlanSaga);
}

export default sagaActions;
